import { render, staticRenderFns } from "./RegForm.vue?vue&type=template&id=8b86aec4&"
import script from "./RegForm.vue?vue&type=script&lang=js&"
export * from "./RegForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports